import { FiInfo as Info, FiPackage as PackageOpen } from 'react-icons/fi';
import {
  TbBug as Bug,
  TbCrown as Crown,
  TbGauge as Gauge,
  TbListSearch as ListSearch,
  TbPencil as Pencil,
  TbRadar as Radar,
  TbSparkles as Sparkles,
  TbTrophy as Trophy,
  TbWallet as Wallet,
} from 'react-icons/tb';
import { FiFlag as Flag, FiLink2 as Link2, FiSearch as Search } from 'react-icons/fi';
import type { IconType } from 'react-icons';
import pricingData, { plans } from './pricing';
import type { ComparisonTool, WithIcon } from './types';

export const iconMap: Record<string, IconType> = {
  bug: Bug,
  crown: Crown,
  flag: Flag,
  gauge: Gauge,
  link: Link2,
  'list-search': ListSearch,
  pencil: Pencil,
  radar: Radar,
  search: Search,
  sparkles: Sparkles,
  trophy: Trophy,
  wallet: Wallet,
};

const { settings, assets, companyInfo, ui } = pricingData;

export { settings, assets, companyInfo, ui };

export const minimumWalletTopUp = settings.minimumWalletTopUp;
export const walletAmountStep = settings.walletAmountStep;
export const taxRate = settings.taxRate;
export const trackerConfig = pricingData.addons.tracker;
export const mentoringConfig = pricingData.addons.mentoring;
export const walletConfig = pricingData.addons.wallet;
export const comparisonConfig = pricingData.comparison;
export const invoiceWatermark = assets.invoiceWatermark;
export const mizfaLogo = assets.mizfaLogo;

export const sortedPlans = Object.values(plans).sort(
  (first, second) => first.order - second.order,
);
export const sortedComparisonPlanRows = [...comparisonConfig.planRows].sort(
  (first, second) => first.order - second.order,
);
export const sortedComparisonPriceRows = [...comparisonConfig.priceRows].sort(
  (first, second) => first.order - second.order,
);
export const sortedTools = [...comparisonConfig.tools].sort(
  (first, second) => first.order - second.order,
);
export const sortedAddonCards = Object.values(pricingData.addons).sort(
  (first, second) => first.order - second.order,
);
export const sortedProjectTools = [...pricingData.projectTools].sort(
  (first, second) => first.order - second.order,
);

export const numberFormat = new Intl.NumberFormat('fa-IR');
export const THEME_PRIMARY = 'var(--pricing-accent)';

export const keywordOptions = Array.from(
  {
    length:
      (trackerConfig.keywordRange.max - trackerConfig.keywordRange.min) /
        trackerConfig.keywordRange.step +
      1,
  },
  (_, index) =>
    trackerConfig.keywordRange.min + index * trackerConfig.keywordRange.step,
);

export const planComparisonRows = sortedComparisonPlanRows;

export const toolCatalog: WithIcon<ComparisonTool>[] = sortedTools.map(
  (tool) => ({
    ...tool,
    icon: iconMap[tool.icon] || Info,
    limits: tool.limits
      ? [...tool.limits].sort((first, second) => first.order - second.order)
      : [],
    features: [...tool.features].sort(
      (first, second) => first.order - second.order,
    ),
  }),
);

export const addonCatalog = sortedAddonCards.map((addon) => ({
  ...addon,
  icon: iconMap[addon.icon] || PackageOpen,
}));
